import { Differentiation } from 'approot/shared/differentiation/differentiation.constants';

export function getDifferentiatedAssessmentTitle(
  differentiation: Differentiation | null,
  unitQuizLabel: string
) {
  switch (differentiation) {
    case Differentiation.SelfAssessment:
      return 'Self-Assessment';
    case Differentiation.AnchorMap:
      return 'Anchor Map';
    case Differentiation.UnitQuiz:
      return unitQuizLabel;
    default:
      return 'Assessment with Differentiation';
  }
}
